import Vue from "vue";
import Router from "vue-router";
import History from "@/utils/history";

Vue.use(Router);
Vue.use(History);

Router.prototype.goBack = function () {
  this.isBack = true;
  this.back();
};

/* Router Modules */
import listRouter from "./modules/list";
import videoRouter from "./modules/video";
import registeredRouter from "./modules/registered";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
    path: "/",
    name: "home",
    component: () => import("@/views/Home")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login")
  },
  {
    path: "/redirect/:path*",
    name: 'redirect',
    component: () => import("@/views/Redirect")
  },
    listRouter,
    registeredRouter,
    videoRouter,
  {
    path: "/browser",
    name: "browser",
    component: () => import("@/views/BrowserDetect")
  },
  {
    path: "/ua",
    name: "userAgent",
    component: () => import("@/views/UserAgent")
  },
  {
    path: "/green",
    name: "greenChannel",
    component: () => import("@/views/GreenChannel")
  },
  { path: "*", redirect: "/login" },
  ]
});

export default router;